// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1z2J8","label":"Labeled_label__2y9BP","divider":"Labeled_divider__1mTkD"};